// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__1H6by","largeButton":"CloseButton_largeButton__1A5xB","sending":"CloseButton_sending__2MMOK"};